import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass/styled-components';
import { Loader } from '@getro/rombo';
import { TreeNode } from './TreeNode';
import { useListsNavTree } from './hooks/useListsNavTree';
import { FolderTreeStyles } from './hooks/useTreeStyles';

export const ListsNavTree = ({ slug }) => {
  const {
    network,
    expandedFolders,
    serverTree,
    isLoading,
    toggleFolder,
    parentIndex,
    expandFolder,
    moveListToFolder,
    moveFolder,
    updateFolder,
    createFolder,
    deleteSharedList,
    deletingList,
    duplicateSharedList,
    duplicatingList,
    deleteFolder,
    deletingFolder,
    selectedListId,
    activeFolderIds,
  } = useListsNavTree({ slug });

  return (
    <Flex flexDirection="column" width="100%" sx={{ gap: '2px', py: '4px' }}>
      <FolderTreeStyles />
      {isLoading && <Loader size="small" />}
      {!isLoading && (serverTree?.length || 0) === 0 && (
        <Text textAlign="left" color="text.subtle" py="8px" px="8px" fontSize="12px" lineHeight="16px">
          Organize your contacts using lists, and optionally share them with companies.
        </Text>
      )}
      {!isLoading &&
        (serverTree || []).map((item) => (
          <TreeNode
            key={`${item.type}-${item.id}`}
            item={item}
            level={0}
            slug={slug}
            isExpandedLookup={(id) => !!expandedFolders[id]}
            toggleFolder={toggleFolder}
            parentIndex={parentIndex}
            tree={serverTree || []}
            expandFolder={expandFolder}
            moveListToFolder={moveListToFolder}
            moveFolder={moveFolder}
            updateFolder={updateFolder}
            createFolder={createFolder}
            deleteSharedList={deleteSharedList}
            deletingList={deletingList}
            duplicateSharedList={duplicateSharedList}
            duplicatingList={duplicatingList}
            deleteFolder={deleteFolder}
            deletingFolder={deletingFolder}
            selectedListId={selectedListId}
            activeFolderIds={activeFolderIds}
            networkId={network.id}
          />
        ))}
    </Flex>
  );
};

ListsNavTree.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default ListsNavTree;
